/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'

// HOOKS
// import { useWindowSize } from './useWindowSize'
// import { useDimensions } from './useDimensions'

import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/scrollbar/scrollbar.scss';

import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Link, Image } from '@ta-interaktiv/contentbricks'

// import { Litzmannstadt } from '../litzmannstadt/main.component.tsx';
import { Litzmannstadt } from '../litzmannstadt/main.component.tsx';
import { Box } from '../box/main.component.tsx';
import { Letters } from '../letters/main.component.tsx';

// TODO Set the correct article ID here
const ARTICLE_ID = '467532538045'

const D = props => <h4 className='date'>{props.children}</h4>
const T = props => <h4>{props.children}</h4>

export function AppComponent() {

  return (
    <div className='index'>
      <Masthead inverted articleId={ARTICLE_ID}  />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='titlewrapper'>
          <div className='ui container'>
            <div className='ui header'>
              <h1>Briefe aus der Vergangenheit</h1>
              <h2>
                Ein Zürcher findet Briefe einer ihm unbekannten jüdischen Verwandten, die von den Nazis ermordet wurde. Er macht sich auf die Suche nach ihrer Geschichte und seinen Wurzeln. Wir begleiten ihn dabei.
              </h2>
            </div>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Hélène Arnet</div>
          </div>
          <div className='ta text'>
            <p>
              Patrick Gutenberg, Zürcher Fotograf, Jahrgang 1966, legt zwei Rosen vor dem Eingang eines Mehrfamilienhauses am Rande der Hamburger Innenstadt nieder. Es ist der 27. Juni 2021, morgens kurz nach elf Uhr. Gutenberg ist am Ziel einer Reise, in deren Verlauf er ein anderer Mensch wurde. Kein besserer, kein schlechterer, aber ein anderer. Und mehr sich selber.
            </p>

            <D>Spanien, 2016</D>
            <p>
              Es war eine fordernde Zeit für Patrick Gutenberg. Eben war sein Vater gestorben, den er nicht mehr so oft gesehen hatte, seit seine Eltern nach Spanien ausgewandert waren. Trotzdem schmerzte der Verlust. Nun musste er deren Haus räumen. Er hatte weder Zeit dafür noch Lust darauf. Die Mulde vor dem Haus füllte sich.
            </p>
            <p>
              Im Studio des Vaters fand er einen grossen gelben Briefumschlag, der aussah, als ob er seit Jahrzehnten nicht mehr geöffnet worden war. Er schaute kurz rein: alte Familienfotos und ein paar Briefe. Kurz zögerte er, legte sie aber dann auf den Stapel, den er nach Hause nehmen wollte. Beizeiten wollte er all das einmal genauer durchgehen. Heute plagt ihn die Vorstellung, dass er damals möglicherweise unachtsam Dokumente oder Fotos vernichtet hat, die ihm heute bedeutsam erscheinen.
            </p>
            
            <D>Zürich, März 2020</D>
            <p>
              Patrick wurde von Corona in seiner Arbeit als Fotograf – auch für diese Zeitung – ausgebremst. Er hat plötzlich Zeit. Er nimmt sich den Stapel vor, den er damals aus Spanien mitgenommen hat, und stösst dabei auf den grossen gelben Briefumschlag. Er studiert die Fotos, kramt in seinem Gedächtnis, ob ihm jemand von den zumeist streng dreinschauenden Personen auf den Bildern irgendwie bekannt vorkommt. Dann öffnet er den ersten Brief und liest Ort und Datum: «Hamburg, 17. 1. 38.»
            </p>
            <p>
              Damit beginnt Patrick Gutenbergs Reise: Eine Reise in die Vergangenheit seiner jüdischen Familie. Eine innere Reise, die ihn erschüttert und fasziniert zugleich, die ihm Rätsel aufgibt und manches klar macht. Aber auch eine reale Reise, die ihn nach Berlin, Hamburg und später vielleicht sogar nach Polen führt. Wir begleiten ihn dabei.
            </p>

          </div>
        </div>
      </div>

      <div className='ui graphic container'>
        <img
          className='ui image fluid'
          src={require('../../images/patrick.jpg')}
        />
        <div className='ta secondary caption'>Die Reise führte in Hamburg auch zum Lohseplatz, wo einst der Hannoversche Bahnhof stand.   Heute entsteht dort eine Gedenkstätte zu den Deportationen von Juden aus Hamburg. Foto: Patrick Gutenberg</div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>

            <p>Auf dieser inneren und realen Reise wird er vielen Personen begegnen. Bereits bekannten und bisher unbekannten. Wir beschränken uns für diesen Bericht auf zehn. Die Hauptpersonen sind Patrick Gutenberg und seine Urgrosstante Lea Stemmer (manchmal Tante Leicie genannt) mit ihrem Mann Moritz Stemmer. Dann: Patricks Vater Hermann Gutenberg und seine Grossmutter Lea Gutenberg-Wohlmann (genannt Oma Leitschi).</p>

            <p>Weiter: Etel Bernstein, eine Schwester von Lea Stemmer, und ihr Mann Nathan, sowie eine entfernte Verwandte, die in Miami USA lebt: Henny Brener. Zum Schluss erscheinen im Zusammenhang mit dem Stolpersteinprojekt noch der Künstler Gunter Demnig und der Bildhauer Michael Friedländer kurz auf der Bildfläche.</p>

            <D>Zürcher Oberland, 1987</D>
            <p>
              Patrick ist 21 Jahre alt und trauert um seine Grossmutter. Zu seiner Grossmutter väterlicherseits, Oma Leitschi, hatte er eine enge Beziehung, seit er als 2-Jähriger sieben Monate bei den Grosseltern gelebt hatte. Er hat sie aber nie gefragt, was «früher» war.
            </p>
            <p>
              Er ist im Zürcher Oberland aufgewachsen. «Einem Dorf ohne Bahnhof, aber mit vielen Einfamilienhäusern», so erzählt er. Sein Umfeld: Reihenhaus, Vater Kaderangestellter in der nahe gelegenen Chemiefabrik, Mutter Hausfrau, ein jüngerer Bruder. Ein bisschen anders als die andern sind sie aber schon: «Ja, wir waren eine jüdische Familie.»
            </p>

            <p>
              Mit dreizehn feierte er seine Bar-Mizwa, an hohen Feiertagen gehen sie nach Zürich in die Synagoge. Er beschreibt heute das Verhältnis seiner Familie zur jüdischen Tradition: «Am Freitagabend feierten wir zusammen den Beginn des Schabbats, assen aber auch manchmal Schinkenbrot.» Gross reflektiert habe er damals seine jüdischen Wurzeln nicht.
            </p>
            <p>
              Auch mit seinem Vater sprach er selten über «solche Dinge». Die Briefe, die er nun gefunden hat, kamen nie zur Sprache. Hätte er mehr fragen sollen? «Sie hätten vielleicht etwas erzählt», denkt er heute. «Immerhin hatten sie die Briefe aufbewahrt.» Ob der Vater überhaupt gewusst hat, was darin steht? «Ich weiss es nicht», sagt Patrick.
            </p>

            <T>Der erste Brief</T>
            <p style={{fontStyle: "italic"}}>
              Hamburg, 7/11. 1936<br />
              Liebe Leitschi!
            </p>

            <p>
              So beginnt der erste Brief, den Patrick Gutenberg entzifferte. Er ist in sauberer, altertümlicher Schnürlischrift verfasst. Auf der letzten der vier Seiten werden die Zeilen immer enger, weil die Schreiberin offenbar viel zu erzählen hatte. Unterschrieben war der Brief von «Tante Leicie».
            </p>

            <div className='ui graphic container'>
              <img
                className='ui image fluid'
                src={require('../../images/ersterbrief.jpg')}
              />
              <div className='ta secondary caption'>Einer der Briefe der Urgrosstante Lea Stemmer an Patrick Gutenbergs Grossmutter. Foto: Patrick Gutenberg</div>
            </div>            

            <p>
              Patrick hatte noch nie von einer «Tante Leicie» gehört, obwohl es durchaus Familientreffen gab. Die Adressatin hingegen kannte er sehr gut. Seine Oma Leitschi! Woher dieser Name kommt? «Ich habe mich das nie gefragt», sagt Patrick. «Sie war einfach meine Oma Leitschi.» Die Oma hiess Lea zum Vornamen. Die unbekannte «Tante» auch, wie sich später herausstellen wird. «Mag sein, dass Leitschi ein Kosename für Lea ist.»
            </p>

            <p>
              Was ihn aber mehr beschäftigte: Diese unbekannte «Tante Leicie» kannte den Kosenamen seines Vaters. Sie schreibt: «Wie gerne möchte ich den goldigen Pezi-Bueb sehen und ans Herz drücken.» – «Pezi, so nannte meine Grossmutter meinen Vater.»
            </p>
            <p>
              Vordergründig beklagt sich in dem Brief eine Tante aus Hamburg bei ihrer Nichte, dass ihre Angehörigen ihr zu wenig oft schreiben. Auch erzählt sie, dass ihr Mann leidend sei und in Kur war. Die Adresse lautete: Tricotwarenfabrik, Forchstrasse 28, Zürich 6. Dort betrieb die Nichte – also Patricks Oma Leitschi – zusammen mit ihrem Mann ein Textilwaren-Geschäft.
            </p>

          </div>
        </div>
      </div>

      <div className='ui graphic container'>
        <img
          className='ui image fluid'
          src={require('../../images/forchstrasse.jpg')}
        />
        <div className='ta secondary caption'>Die Briefe waren an die Forchstrasse 28 in Zürich adressiert. So sah das Haus von Gutenbergs Grosseltern damals aus. Foto: Privat (fotografiert in den 1930er-Jahren).</div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>            

            <T>Sanok (Polen)/Hamburg</T>
            <p>
              So stiess Patrick Gutenberg auf seine Urgrosstante Lea Stemmer. Später wird er folgendes über sie herausfinden: Sie wurde am 11. September 1889 als Lea Bernfeld in Sanok (Polen) geboren und war die jüngste von elf Geschwistern. Als junge Frau arbeitete sie in Sanok als Gerichtsangestellte. Sie heiratete 1911, wahrscheinlich in Sanok, Moritz Stemmer, geboren am 25. März 1886.
            </p>
            <p>
              Die beiden lebten in Hamburg, zuletzt an der Heider-Strasse 22, die damals noch Heidestrasse hiess, und im heutigen Stadtteil Hoheluft-Ost im Norden der Hansestadt liegt. Sie hatten keine Kinder.
            </p>

            <T>Die weiteren Briefe</T>
            <p>
              In dem gelben Umschlag befanden sich weitere sechs Briefe und zwei Postkarten, die Lea Stemmer an ihre Nichte schrieb. In diesen wird zwischen den Zeilen immer deutlicher, wie verzweifelt die Situation für das Ehepaar Stemmer wird. Allerdings beschränkt sich die Schreibende meist auf Andeutungen, und es wird nicht ganz klar, ob sie es tut, weil sie die Zensur fürchtet oder weil sie ihre Verwandten nicht zu sehr unter Druck setzen will. Klar wird, dass sie sich um eine Ausreise nach Amerika oder in die Schweiz bemühte und sich dabei Unterstützung von ihren Angehörigen erhoffte.
            </p>
            <p>
              13. Oktober 1938: <i>(...) Du schreibst, dass du mich gerne bei Dir sehen möchtest, so muss ich dir antworten, dass ich möchte ebenso gerne bei Euch sein. Aber wie kann das möglich sein? Weisst Du vielleicht einen Ausweg?»</i>
            </p>
            <p style={{fontStyle: 'italic'}}>Hier erfahren Sie mehr über den Inhalt der Briefe.</p>
          </div>
        </div>

        <Letters />

        <div className='ui text container'>
          <div className='ta text'>
            <D>Zürich, Winter 2020/21</D>
            <p>
              Patrick Gutenberg lässt das Schicksal von Lea und Moritz Stemmer keine Ruhe mehr. Er sagt: «Seit ich von ihnen weiss, ist die Schoah bei mir angekommen.» Er erinnert sich, dass diese unfassbare, systematische Verfolgung und Ermordung der jüdischen Bevölkerung durch die Nationalsozialisten ihn bereits als Jugendlichen stark beschäftigte. Mit fünfzehn habe er mehr Konzentrationslager mit Name und Ortsangabe gekannt als Fussballclubs.
            </p>
            <p>
              Und doch habe er weder mit seinen Eltern noch mit seinen Grosseltern darüber gesprochen. «Das Thema war zwar nicht tabu, aber ich spürte, dass sie nicht darüber reden wollten.»
            </p>
            <p>
              So blieb der Holocaust für ihn etwas, was er nicht direkt mit seiner Familie in Verbindung brachte. Ein Ereignis in Schwarzweiss, nicht in Farbe. Nun weiss er: «Wenn ein jüdischer Mensch zwei Steine seines familiären Fundaments anhebt, klafft dort bestimmt ein Loch, das von der Schoah herrührt. Selbst wenn dieser, wie ich, als Nachgeborener in behüteten Verhältnissen im Zürcher Oberland aufgewachsen ist.»
            </p>
            <p>
              Diese Steine werden nun zum Sinnbild für seine Reise. Auch in Form von Puzzlesteinen, die er zusammensucht, um sich ein Bild von dem zu machen, was damals geschah.
            </p>

            <T>Fate: murdered</T>
            <p>
              Er forscht auf Genealogiewebseiten nach, nimmt Kontakt mit fernen Verwandten auf, reist virtuell nach Jerusalem, ins Yad Vashem, der bedeutendsten Gedenkstätte für die nationalsozialistische Judenvernichtung, wo auch eine zentrale Datenbank der Holocaustopfer geführt wird.
            </p>

            <p>
              Eine Momentaufnahme: Patrick sitzt zu Hause vor seinem Laptop und sieht vor sich in der Yad-Vashem-Datenbank die Felder, die er ausfüllen muss: Last/Maiden Name, First Name, Place. Dann der Knopf «Search».
            </p>

            <p>
              Er ist hin- und hergerissen: Ein Treffer würde bedeuten, dass das, was er aufgrund der Briefe befürchtet, Tatsache wird. Schwarzweiss wird Farbe. Wir stellen uns vor, dass er den Atem anhält. Dass er die Geräusche seiner Umgebung nicht mehr wahrnimmt. Er liest: «1 results for victims/individuals» und unter «Fate», Schicksal, «murdered».
            </p>


          </div>

          <div className='ui graphic container center'>
            <img
              className='ui image'
              src={require('../../images/database.gif')}
            />
            {/* <div className='D:ta secondary caption'>Das einzige Bild der Stemmers: Lea und Moritz.</div> */}
          </div>    

            <div className='ta text'>            

            <D>Hamburg, 1930-er Jahre</D>
            <p>Die Heider-Strasse, in der die Stemmers um 1936 wohnten, liegt unweit des Quartiers Grindel, das seit dem 19. Jahrhundert das Zentrum der jüdischen Gemeinde war. 1933, bei der Machtergreifung Hitlers, lebten dort etwa 25’000 Jüdinnen und Juden.</p>
            <p>In der Nacht vom 9. auf den 10. November 1938 stürmte der nationalsozialistische Mob jüdische Geschäfte und Einrichtungen. Die grosse Synagoge am Bornplatz (heute Joseph-Carlebach-Platz) wurde angezündet. Die schikanöse Behandlung der jüdischen Bevölkerung nimmt stetig zu. Bereits am 1. April 1933 hatten SA-Leute im Grindelquartier zum Boykott jüdischer Geschäfte aufgerufen: «Kauft nichts bei Juden.»</p>


            </div>
        </div>
      </div>

      <div className='ui graphic container'>
        <img
          className='ui image fluid'
          src={require('../../images/synagoge.jpg')}
        />
        <div className='ta secondary caption'>Die grosse Synagoge am Bornplatz wurde 1938 verwüstet und 1939 zerstört. Heute bestehen Pläne, an der Stelle wieder eine Synagoge zu errichten. Foto: PD</div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>  


            <p>Stein für Stein trägt Patrick Gutenberg über das Schicksal von Stemmers zusammen: 1937 war Moritz Stemmer gezwungen worden, seinen Eiergrosshandel aufzugeben. Eine Lebensversicherung, die bis 1971 gelaufen wäre, musste er sich zu einem Spottpreis auszahlen lassen. Der lungenkranke Moritz kontrollierte und verpackte seither in den Kühlhäusern des Freihafens die importierten Eier. Auch Lea arbeitete in diesem Lager als Packerin.</p>

            <T>Die letzten beiden Briefe</T>
            <p style={{fontStyle: 'italic'}}>
              12. August 1939<br />
              (...) So möchte ich Dich liebe Leitschi bitten uns zu schreiben, was wir unternehmen sollen, dass wir doch nach der Schweiz kommen können. (...) Glaube mir, liebe Leitschi, dass meine Kräfte am Ende sind, denn ich mache mir furchtbare Sorgen, was aus uns werden soll. (...)
            </p>
            <p style={{fontStyle: 'italic'}}>
              25. September 1939<br />
              (…) Das Päckchen haben wir Freitag (am Erev Jom Kippur) mit grosser Freude erhalten und wir danken Dir von Herzen, dass Du l. Leitschi an uns denkst. Ich muss Dir gestehen, dass es uns sehr willkommen war (…).
            </p>

          </div>
        </div>
      </div>

      <div className='ui graphic container'>
        <img
          className='ui image fluid'
          src={require('../../images/brief39.jpg')}
        />
        <div className='ta secondary caption'>«Glaube mir, liebe Leitschi, dass meine Kräfte am Ende sind, denn ich mache mir furchtbare Sorgen, was aus uns werden soll»</div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>      

            <D>Zürich, Anfang Februar 2021</D>
            <p>Patrick Gutenberg hat unzählige Akten durchstöbert, Kontakt mit dem jüdischen Museum in Berlin aufgenommen und Ahnenforschung betrieben. Verwehrt geblieben ist ihm, dem Berufsfotografen, aber bisher ein Bild von Lea und Moritz. Schon ganz zu Beginn unseres ersten Gesprächs klagte er: «Ich konnte bis jetzt kein Bild von ihnen finden.» Er wiederholt diesen Satz später mehrfach.</p>
            <p>Am 3. Februar erhält er eine Mail von einer Henny Brener aus Miami, einer jener Personen, auf die er über eine Genealogiewebseite gestossen ist. Im Anhang ein Bild von Lea und Moritz Stemmer. Wie sich später herausstellte, ist sie eine Enkelin von Etel und Nathan Bernstein und damit eine Grossnichte Lea Stemmers.</p>
            <p>Sie ist allerdings zuerst kurz angebunden, wusste sie doch bisher nichts von Verwandten in der Schweiz. Auf Patricks erstes Mail reagiert sie mit einer sehr knappen Antwort: «Hello..I am Henny Brener…in reference to what do you want to contact me?»</p>
            <p>Eisbrecher ist das Foto seiner Bar-Mizwa-Feier, die in Jerusalem stattfand, welches er ihr schickt. Es zeigt ihn mit seinen Eltern und ein paar Verwandten an der Klagemauer. Darunter befand sich auch Henny’s Vater, der sich damals zufällig in Israel aufhielt.</p>
          </div>

          <div className='ui graphic container center'>
            <img
              className='ui image'
              src={require('../../images/leaundmoritz.jpg')}
            />
            <div className='ta secondary caption'>Endlich ein Bild: Lea und Moritz Stemmer, wohl kurz nach ihrer Heirat 1911. Foto: Privat</div>
          </div>    

          <div className='ta text'>        

            <p>Es ist also ein Bild, das zum lang gesuchten Bild führt. Aufgenommen wurde das Foto des Ehepaars Stemmer in Sanok. Es ist undatiert, dürfte aber so um 1911 entstanden sein. «Gut möglich, dass es aus Anlass ihrer Heirat entstanden ist», sagt Patrick.</p>
            <p>Nun haben Lea und Moritz Stemmer also ein Gesicht: Das Bild zeigt eine ernst, fast abweisend dreinblickende Frau mit streng hochgebundenen Haaren und vor der Brust verschränkten Armen. Neben ihr ein schlanker Mann in etwas zu grosser Kleidung, den Schalk in den Augen, die Arme locker verschränkt.</p>

            <T>Die letzte Nachricht</T>
            <p>November 1941, Lea Stemmers Schwester Etel Bernstein, die auch in Hamburg lebte, schreibt an ihre Kinder, die rechtzeitig nach Amerika ausgewandert waren:</p>
            <p style={{fontStyle: 'italic'}}>
              (...) Stemmers reisten am 23. Oktober ab. Wir halfen ihnen beim Packen und begleiteten sie zur Besammlungsstelle. Wir verabschiedeten uns gefasst. Sie werden uns ihre neue Adresse schicken. (...)
            </p>
            <p>
              Das sind die letzten direkten Nachrichten über Lea und Moritz Stemmer.
            </p>

          </div>
        </div>
      </div>      

      <div className='ui graphic container'>
        <img
          className='ui image fluid'
          src={require('../../images/hannoverschenbh.jpg')}
        />
        <div className='ta secondary caption'>Tausende von Namen erinnern am ehemaligen Standort des Hannoverschen Bahnhofs an die deportierten Hamburger Jüdinnen und Juden. Darunter befinden sich auch diejenigen von Lea und Moritz Stemmer. Foto: Patrick Gutenberg</div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>            

            <D>23. Oktober 1941 Hamburg/Łódź</D>
            <p>Folgendes hat Patrick Gutenberg, Puzzlestein für Puzzlestein, über ihr weiteres Schicksal zusammengetragen: Lea und Moritz Stemmer wurden in der ersten grossen Deportationswelle am 25. Oktober 1941 von Hamburg nach Łódź gebracht. Zusammen mit 1031 weiteren Hamburger Jüdinnen und Juden.</p>

            <div className='ui graphic container'>
              <img
                className='ui image fluid'
                src={require('../../images/40_1386_3.jpg')}
              />
              <div className='ta secondary caption'>Deportation vom Ghetto Łódź in ein Vernichtungslager, wahrscheinlich nach Chełmno, wo auch Lea Stemmer vergast wurde. Foto: Staatsarchiv Łódź</div>
            </div>


            <p>Moritz ist bereits am 22. April 1942 in Łódź gestorben, möglicherweise weil die Verhältnisse dort und die Zwangsarbeit seine ohnehin angeschlagene Gesundheit vollends ruinierte. Lea ist am 10. Mai 1942 im erst vor kurzem in Betrieb genommenen Vernichtungslager Chełmno/Kulmhof ermordet worden. Das Lager wird vom Historiker Wolfgang Scheffler als «eine Gaswagenstation, die aus einigen Gebäuden bestand» beschrieben (am Ende des Artikels können Sie mehr über die Deportation und das Ghetto Łódź erfahren).</p>
            <p>Ihr Schicksal teilten damals viele Jüdinnen und Juden aus Hamburg und Umgebung: Ab Oktober 1941 wurden über 5848 noch in Hamburg verbliebenen Juden nach Osteuropa deportiert. Der letzte Transport nach Theresienstadt fand am 14. Februar 1945 statt. 5296 Menschen wurden ermordet oder starben an Hunger und Erschöpfung.</p>
            <p>Auch Leas Schwester Etel und ihr Mann Nathan Bernstein gelang die Ausreise nicht. Sie wurden im Juli 1942 voneinander getrennt nach Theresienstadt deportiert. Nathan starb dort am 17. April 1943, Etel wurde am 15. Mai 1944 in Auschwitz ermordet.</p>

            <D>Zürich, Josefstrasse, 30. März 2021</D>
            <p>Draussen, rund um den Idaplatz im Stadtzürcher Kreis 3, wo Patrick wohnt, stehen die Kirschbäume in voller Blüte. Patrick hat sich in sein Atelier an der Josefstrasse zurückgezogen, um Lea Stemmers Briefe zu fotografieren. Zuvor hat er im Internet stundenlang nach einem geeigneten Hintergrund gesucht. Und schliesslich gefunden. Eine altrosa Tapete mit verblassenden floralen Ornamenten.</p>
            <p>Neben einen Brief positioniert er das einzige Foto, das er von Lea Stemmer und ihrem Mann hat. Und darunter legt er ein Bild von seiner Grossmutter, als sie ähnlich alt war. Erst jetzt fällt die Familienähnlichkeit auf. Henny Brener, mit der er unterdessen per Mail regelmässigen Kontakt pflegt, hat Lea Stemmer einmal mit den Worten charakterisiert: «Sie stand gerne im Mittelpunkt.» Patrick schaut auf die Bilder und sagt lächelnd über seine Grossmutter: «Oma Leitschi auch.»</p>
          </div>
        </div>
      </div>

        <div className='ui graphic container'>
          <img
            className='ui image fluid'
            src={require('../../images/briefe2.jpg')}
          />
          <div className='ta secondary caption'>Lea und Moritz Stemmer, wenigstens auf den Fotos vereint mit Patrick Gutenbergs Grossmutter Lea Gutenberg-Wohlmann. Foto: Patrick Gutenberg</div>
        </div> 

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'> 
            <D>Berlin, 29 Mai 2021</D>
            <p>Patrick Gutenberg hat einen Entschluss gefasst. Er kontaktiert die Organisation «Stolpersteine». Sie erinnert an Menschen, die Opfer der nationalsozialistischen Verfolgungen wurden, durch kleine Gedenktafeln in Form von Pflastersteinen. Diese werden im Boden vor jenen Häusern gesetzt, wo diese Menschen zuletzt freiwillig lebten. Patrick will an der Heider-Strasse 22 zwei solche «Stolpersteine» setzen.</p>
            <p>Und er will dabei sein, wenn die Steine entstehen. Er reist nach Berlin zum «Stolpersteinmacher», dem Bildhauer Michael Friedländer, verbringt einen ganzen Samstag in dessen Stolpersteinschmiede, dokumentiert, will unbedingt festhalten, wie die Namen, die beiden Schicksale, die fast vergessen wurden, ins Kupferblech getrieben werden.</p>
          </div>
        </div>
      </div>

      <div className='ui graphic container stolpersteingallery'>
        <Swiper
          spaceBetween={0}
          slidesPerView={1}
          navigation
          // scrollbar={{ draggable: true }}
          loop = {false}
        >
        <SwiperSlide><Image file={require('../../images/stolpersteine/1.jpg')} source="Von Hand werden die Stolpersteine von Lea und Moritz Stemmer gefertigt. Fotos: Patrick Gutenberg"/></SwiperSlide>
        <SwiperSlide><Image file={require('../../images/stolpersteine/2.jpg')} /></SwiperSlide>
        <SwiperSlide><Image file={require('../../images/stolpersteine/3.jpg')} /></SwiperSlide>
        <SwiperSlide><Image file={require('../../images/stolpersteine/4.jpg')} /></SwiperSlide>
        <SwiperSlide><Image file={require('../../images/stolpersteine/5.jpg')} /></SwiperSlide>
        <SwiperSlide><Image file={require('../../images/stolpersteine/6.jpg')} /></SwiperSlide>
        </Swiper>
          
        {/* <img
          className='ui image fluid'
          src={require('../../images/stolperstein.jpg')}
        />
        <div className='ta secondary caption'>XXX</div> */}
      </div> 

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>

            <p>Übertreibt er jetzt nicht ein bisschen? «Ich muss das jetzt machen», antwortet Patrick. «Ich will nicht, dass die Briefe weiter stumm in unserer Familie von Generation zu Generation weitergegeben werden.»</p>
            <p>Der Umstand, dass sowohl seine Grossmutter als auch sein Vater die Briefe aufbewahrten, aber nie darüber sprachen, zeigt, wie schmerzhaft die Erinnerung sein musste. Vielleicht waren da bei Oma Leitschi Schuldgefühle, zu wenig getan zu haben, um die Verwandten zu retten?</p>
            <p>Bekannt ist auch, dass Verschonte sich häufig mit der Frage plagten, weshalb sie das Glück hatten, überlebt zu haben, und die andern nicht. Patrick Gutenberg, der Enkel und Sohn, will aber nicht vergessen, er will erinnern. «Ich will Lea Stemmer meine Stimme geben.»</p>

          </div>
        </div>

        <Box
          title = '«Ich weiss, was ich mache, warum ich es mache»'
          lead = 'Michael Friedländer fertigt jeden Stolperstein von Hand. Jede Zahl, die er einmeisselt, nagelt sich auch in den Kopf, erzählt er im Video.'
        >
          <div className='outer'>
          <div className='videowrapper'>
            <iframe uv="uv439121" className="externalNNIFrame" src="https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger%7CvideoId@439121%7CshowLogo@1%7CautoStart@0%7Cmute@0%7CshowAds@0%7CpreviewPath@https://server025.newsnetz.tv/439121/frame-1-439121.jpg%7Cplatform@desktop" frameBorder={0}></iframe>
          </div>
          </div>
        </Box>

        <div className='ui text container'>
          <div className='ta text'> 

            <D>27. Juni 2021, Heider-Strasse 22, Hamburg</D>
            <p>Vor dem Haus Heider-Strasse 22 hat sich eine kleine Gruppe von Menschen eingefunden, die regelmässig an solchen Steinsetzungen teilnehmen. Eine schlanke ältere Frau fragt Patrick: «Sind Sie der Angehörige?» Er reagiert verwirrt. «Angehöriger» scheint sich für ihn irgendwie falsch anzuhören. Er erklärt die Verwandtschaft. Einer von ihnen sagt: «In den letzten Jahren sind es immer häufiger Menschen aus der Enkelgeneration, die für Angehörige solche Mahnsteine setzen lassen.»</p>
            <p>Einige Gebäude in der Häuserzeile zeigen noch die gutbürgerlichen Fassaden des Vorkriegs-Hamburgs, obwohl diese Gegend stark zerbombt wurde. Am letzten Wohnort der Stemmers steht aber ein schlichter Bau aus den 1960er-Jahren.</p>
            <p>Auf dem untersten Balkon erscheint eine betagte Frau. Das Gehen bereitet ihr Mühe. Sie gibt vor, die Stiefmütterchen in den Balkonkistchen zu begutachten, wirft aber verstohlene Blicke auf die kleine Ansammlung vor ihrer Haustür.</p>


          </div>
        </div>
      </div>

      <div className='ui graphic container'>
        <img
          className='ui image fluid'
          src={require('../../images/stolpersteinsetzung.jpg')}
        />
        <div className='ta secondary caption'>Eine Hausbewohnerin schaut zu, wie die Fotografin Gesche Cordes und ihr Mann an der Heider-Strasse 22 Blumen für Lea und Moritz Stemmer hinlegen. Foto: Patrick Gutenberg</div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>

            <p>Die Frau nickt nur, als ihr erklärt wird, was ansteht. Sie wohne seit 1968 hier, sagt sie dann. Ob sie ein paar Stühle bringen soll, fragt sie. Wir fragen zurück: «Was ist das für ein Gefühl, dass Sie nun immer, wenn Sie das Haus betreten oder verlassen, diesen Stolpersteinen begegnen?» – «Ich finde es gut, dass man das macht. Ich war damals ja noch ein Kind», sagt sie. Dabei überwältigt sie eine Erinnerung. Tränen steigen ihr in die Augen.</p>
            <p>Punkt 11 Uhr fährt Gunter Demnig vor. Der Künstler ist Begründer des Projekts Stolpersteine und ein Mann mit Sinn für den grossen Auftritt. Zusammen mit einem Mitarbeiter stemmt er eine Bodenplatte hoch. Sie sägen und wässern, die Steinsäge kreischt. Steinstaubwolken. Alles geht so schnell, als ob sie im Akkord arbeiten würden. Sie platzieren und betonieren. Und schon glänzen die beiden Gedenksteine, in der Sonne, die exakt jetzt durch die Wolken bricht.</p>
            <p>Patrick Gutenberg hat fotografiert. Er kann nicht anders. Nun legt er den Fotoapparat zur Seite, steht in den Hauseingang und liest zwei Passagen aus den Briefen seiner Urgrosstante aus Hamburg an seine Grossmutter in Zürich vor. «Liebe Leitschi, ...»</p>

          </div>
        </div>
      </div>
      
      <Litzmannstadt />            

      <Footer articleId={ARTICLE_ID} hidePortfolioTeaser hideUserFeedback 
        credits={[
          ['Text', 'Hélène Arnet'],
          ['Fotos Hamburg, Berlin', 'Patrick Gutenberg'],
          ['Fotos Łódź', 'Staatsarchiv Łódź'],
          ['Produktion', 'Simon Huwiler']
          ]} />
    </div>
  )
}
